import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import { memberPortal } from "../member-portal";
import { recaptchaObject } from "../recaptcha";

export class memberRegisterForm {
	private registerForm:any   = $('#member-register-form');
	private memberBase:any = new memberPortal();

	initPopup(): any {
		let _self = this;
		let nameGuideField:any = _self.registerForm.find('#name-guide-field');

		nameGuideField.magnificPopup({
			type:'inline',
			midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		});
	}

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.registerForm.find('input[type="text"], input[type="email"], input[type="password"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * set confirm password validation to match password field
	 */
	initPasswordInputs(): any {
		let _self = this;
		let passwordId:string = 'member--create-password';
		let confirmPassword:any = _self.registerForm.find('#member--confirm-password');

		confirmPassword.attr('data-parsley-equalto', '#'+passwordId);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;


		let titleInput = $('#member-register--title');
		let getTitleOptions = $.Deferred();
		$.get('/content/dam/mas/json/TitleCode.json')
			.done((data:any) => {
					let listItems = "<option value=''> </option>";
					for (let i = 0; i < data.Titles.length; i++) {
						listItems += "<option value='" + data.Titles[i].Code + "'>" + data.Titles[i].Name + "</option>";
					}
					getTitleOptions.resolve(listItems);
			})
			.fail((error:any) => {
			getTitleOptions.reject(error);
		});


		let countryInput = $('#member-register--residing-country');
		let getCountryOptions = $.Deferred();
		$.get('/content/dam/mas/json/countrycode.json')
		.done((data:any) => {
					let listItems = "<option value=''> </option>";
					for (let i = 0; i < data.Countries.length; i++) {
						listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
					}
					getCountryOptions.resolve(listItems);
				})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});


		let cityInput = $("#member-register--pref-departure-city");
		let getCityOptions = $.Deferred();
		$.get('/content/mas-admin/ond/getService.Revenue.json')
		.done((data:any) => {
			let dataParse:any = null;
			if (typeof data === 'string') {
				dataParse= JSON.parse(data);
			}
			else {
				dataParse = data;
			}

			let airportList = dataParse.response;
			let listItems = "<option value=''> </option>";

			for (let key in airportList) {
				let listEl:any = $('<option></option>');

				listEl.attr({'value': airportList[key].airportCode});
				listEl.text(airportList[key].airportName + ', ' + airportList[key].countryName + ' (' + airportList[key].airportCode + ')');

				listItems += listEl.prop('outerHTML');
			}
			getCityOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCityOptions.reject(error);
		});

		$.when(getTitleOptions, getCountryOptions, getCityOptions).done(function(titleOptions:any, countryOptions:any, cityOptions:any) {
			titleInput.html(titleOptions);
			countryInput.html(countryOptions);
			cityInput.html(cityOptions);

			let inputSelectArr = $.makeArray(_self.registerForm
				.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
		});
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr = $('#member-register--date-of-birth');
		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getTime() - 1000*60*60*24*365*2));

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
	}

	/**
	 * [initPhoneInput description]
	 * @return {any} [description]
	 */
	initPhoneInput(): any {
		let _self = this;

		let phoneCodeInput = $('#member-register--personal-phone-mobile-country-code');
		let getPhoneOptions = $.Deferred();

		$.get('/content/dam/mas/json/PhoneCode.json')
		.done((data:any) => {
			let listItems = "<option value=''> </option>";
			for (let i = 0; i < data.Phonecodes.length; i++) {
				listItems += "<option value='" + data.Phonecodes[i].Code + "'>" +data.Phonecodes[i].Code+"</option>";
			}
			getPhoneOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getPhoneOptions.reject(error);
		});

		$.when(getPhoneOptions).done(function(titleOptions:any) {
			phoneCodeInput.html(titleOptions);

			let inputElArr = $.makeArray(_self.registerForm.find('.phoneinput'));
			_self.memberBase.initPhoneInput(inputElArr);
		});


		// change phone number field validation message
		let phoneNumberFields = _self.registerForm.find('.phoneinput input[type="tel"]');

		phoneNumberFields.each((i:number, el:any) => {
			$(el).attr({
				'data-parsley-type-message': 'This value should be a valid number.'
			});
		});
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.registerForm,
			function(validation: any) {
				// all your custom validation here

				// init password validation
				_self.memberBase.customValidationPasswordMinAlpha();
				_self.memberBase.customValidationPasswordAlphanum();

				//Alpha fields - First Name, Last Name
				let alphaInputs = _self.registerForm.find('#member-register--first-name, #member-register--last-name');
				alphaInputs.attr({
					'data-parsley-pattern': '^[a-zA-Z\\s]*$',
					'data-parsley-pattern-message': 'This value is invalid. Please input letters only.',
					'data-parsley-maxlength': '25',
					'maxlength': '25'
				});

				// phone number: integer only
				let phoneInputs:any = $('#member-register--personal-phone-mobile');
				phoneInputs.each((i:number, el:any) => {
					$(el).attr('data-parsley-type', 'number');
				});

				// Password
				let passwordInputs = _self.registerForm.find('#member--create-password, #member--confirm-password');
				passwordInputs.each((i:number, el:any) => {
					$(el).attr({
						'data-parsley-mh-password-alphanum': true,
						'data-parsley-mh-password-min-alpha': true,
						'minlength': '6',
						'maxlength': '12',
						'data-parsley-minlength': '6',
						'data-parsley-maxlength': '12'
					});
				});
			},
			function(validation:any, formData:any) {
				console.log('done!');
				// on success function
				// window.location = window.location.origin + '/members/register-success.html';
			});
	}
	
	isChinaSiteEdition(): any {
		let disableRecaptcha:boolean = false;
		let curPath:string = window.location.pathname;
		let rawPathParams:Array<string> = curPath.split('/');
		for (let i=0, len=rawPathParams.length; i<len; i++) {
			if (rawPathParams[i]==='cn') {
				disableRecaptcha = true;
				break;
			}
		}
		return disableRecaptcha;
	}
	
	initRecaptcha():any {
		let _self = this;
		let recaptchaUrl = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
		let recaptchaId = 'register-form-recaptcha'
		let _body = $('body');

		let recaptchaobj = new recaptchaObject();

		// todo: recaptcha cbObj weirdly doesn't work for this class
		// - if cbObj is declared as a function, it evals before being added to page,
		//   causing syntax error
		// - not critical as this implementation still works, but is inconsistent with
		//   implementation across other classes
		let recaptchaInfo:recaptchaInfo = {
			id: 'register-form-recaptcha',
			cb: 'recaptchaMemRegisterSuccess',
			cbObj: 	function (response:any) {
							(document.getElementById("register-form-recaptcha") as HTMLInputElement).value = "true";
						},
			displayId: 'member-register--grecaptcha',
			formEl: _self.registerForm
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

	/**
	 * populate input fields on page load
	 * @return {any} [description]
	 */
	populateFields(): any {
		let _self = this;
		let inputFields = {
			'title': 		 'member-register--title',
			'firstName': 	 'member-register--first-name',
			'lastName': 	 'member-register--last-name',
			'dateOfBirth':   'member-register--date-of-birth',
			'gender':		 'member-register--gender',
			'country': 		 'member-register--residing-country',
			'contactCCode':  'member-register--personal-phone-mobile-country-code',
			'contactPhone':  'member-register--personal-phone-mobile',
			'contactEmail':  'member-register--personal-email'
		};

		let data = {
			'title': 		 'Mr.',
			'firstName': 	 'Test',
			'lastName': 	 'User',
			'dateOfBirth':   new Date('10/08/1988'),
			'country': 		 'Singapore',
			'gender':		 'Male',
			'contactCCode':  'Singapore (+65)',
			'contactPhone':  '90001234',
			'contactEmail':  'testuser@gmail.com'
		}

		$.each(inputFields, (param:any, inputId:any) => {
			console.log(param, inputId, data[param]);

			let input:any = $('#'+inputId);

			// handle select inputs
			if (input.is('select')) {
				input[0].selectize.setValue(data[param]);
			} else if (input.hasClass('datepicker')) {
				input.datepicker('setDate', data[param]);
				// handle date inputs
			} else {
				// handle all other inputs
				input.val(data[param]);
			}
			input.blur();
			// manually apply state to elements if not added by blur
			input.parent().find('label').addClass('input-filled');
			input.addClass('input-focused');
		});
	}
}

let scope:Element = document.querySelector('#member-register-form');

if (scope) {
	try {
	let memberregisterform = new memberRegisterForm();
	memberregisterform.initPopup();
	memberregisterform.initPasswordInputs();
	memberregisterform.initTextInputs();
	memberregisterform.initSelectizeInputs();
	memberregisterform.initDatepickerInputs();
	memberregisterform.initPhoneInput();
	let disableRecaptcha:Boolean = memberregisterform.isChinaSiteEdition();
	if(!disableRecaptcha){
		memberregisterform.initRecaptcha();		
	}
	memberregisterform.validateForm();

	// if (window.location.hostname === 'localhost') {
	// 	memberregisterform.populateFields();
	// }
	} catch(e) {console.error(e);}
}